import { FC } from "react";
import Modal from "../../Modal";
import styles from "./Referrals.module.scss";
import ModalContent from "../../Modal/ModalContent";
import { showToast } from "@utils/showToast";
import { useWallet } from "@stores/wallet.store";

interface Props {
    isVisible: boolean;
    setIsVisible(isViisble: boolean): void;
}

const Refferals: FC<Props> = ({ isVisible, setIsVisible }) => {
    const notify = () => showToast("Successfully copied to the clipboard", "success");
    const { referralCode, referralPercent, referrals } = useWallet((state) => ({
        referralCode: state.externalWallet.referralCode,
        referrals: state.referrals,
        referralPercent: state.referralPercent,
    }));

    const handleCopy = async () => {
        notify();
        if (!referralCode) return;
        await navigator.clipboard.writeText("https://nestdex.io/?ref=" + referralCode);
    };

    return (
        <Modal isVisible={isVisible} setIsVisible={setIsVisible}>
            <ModalContent classNames={styles.content}>
                <div className={styles.header}>
                    <h2 className={styles.headline}>Referrals</h2>
                    <button className={styles.close} onClick={() => setIsVisible(false)}>
                        <picture>
                            <source
                                srcSet="/images/modal/closemobile.svg"
                                width={7.5}
                                height={7.5}
                                media="(max-width: 768px)"
                            />
                            <img
                                height={12}
                                width={12}
                                src="/images/modal/close.svg"
                                style={{ opacity: 0.4 }}
                                alt="Close modal"
                            />
                        </picture>
                    </button>
                </div>
                <p className={styles.description}>
                    Your friend should follow your link and connect or create a wallet. Your friend will be counted only
                    after making 10 transactions
                </p>
                <div className={styles.blocksVertical}>
                    <div className={styles.block}>
                        <div className={styles.top}>{referrals?.length ?? 12}</div>
                        <div className={styles.bottom}>Friends</div>
                    </div>

                    <div className={styles.block}>
                        <div className={styles.top}>{referralPercent ?? 25}%</div>
                        <div className={styles.bottom}>Referral Percent</div>
                    </div>
                </div>

                <div className={styles.blocks}>
                    <div className={styles.block}>
                        <div className={styles.topGreen}>
                            <span>SOON</span>
                            <img src="/images/modal/nest.svg" alt="" />
                        </div>
                        <div className={styles.bottom}>nest.cashback</div>
                    </div>
                    <div className={styles.block}>
                        <div className={styles.top}>
                            <span>SOON</span>
                            <img src="/images/modal/nest.svg" alt="" />
                        </div>
                        <div className={styles.bottom}>TON cashback</div>
                    </div>
                </div>
                <button onClick={handleCopy} className={styles.button}>
                    <span>nestdex.io/ref={referralCode}</span>
                    <img height={24} width={24} src="/images/profile/copy.svg" alt="" />
                </button>
            </ModalContent>
        </Modal>
    );
};

export default Refferals;
